import { CurrentUserResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type CurrentUserResponseInput = z.input<typeof CurrentUserResponseSchema>;
export type CurrentUserResponseOutput = z.output<typeof CurrentUserResponseSchema>;

export function serializeCurrentUserResponse(payload: CurrentUserResponseInput): CurrentUserResponseOutput {
  return CurrentUserResponseSchema.parse(payload);
}
